import { render, staticRenderFns } from "./deleteTeam.vue?vue&type=template&id=deecc4e6"
import script from "./deleteTeam.vue?vue&type=script&lang=js"
export * from "./deleteTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports